import { type EnableAlertDto, UserNotificationControllerV2ApiFactory } from "@eu.mdotm.api/sphere";
import { getApiGen } from "$root/api/factory";
import { repositoryHelperFactory } from "$root/api/repository";
import { eventBus } from "$root/event-bus";
import { axiosExtract } from "$root/third-party-integrations/axios";
import type { RawAxiosRequestConfig } from "axios";
import debounce from "debounce";

const { newQuery, newAction, invalidate } = repositoryHelperFactory("notificationSettings");

const notificationApi = () => getApiGen(UserNotificationControllerV2ApiFactory);

export const notificationSettingsRepository = {
	notificationSettings: newQuery("notificationSettings", () => axiosExtract(notificationApi().retrieveAllUserAlert())),
	editAlerts: newAction(async (payload: EnableAlertDto[]) => {
		const response = await notificationApi().editAlerts(payload);
		invalidate(notificationSettingsRepository.notificationSettings.partialQueryKey);
		return response;
	}),
	retrieveAllUserPortfolioNotificationsFromPool: newQuery(
		"retrieveAllUserPortfolioNotificationsFromPool",
		(pool?: number) => axiosExtract(notificationApi().retrieveAllUserPortfolioNotificationsFromPool(pool)),
	),
	retrieveAllUserMarketNotificationsFromPool: newQuery("retrieveAllUserMarketNotificationsFromPool", (pool?: number) =>
		axiosExtract(notificationApi().retrieveAllUserMarketNotificationsFromPool(pool)),
	),
	changeReadNotification1: newAction(async (requestBody: string[]) => {
		const response = await notificationApi().changeReadNotification1(requestBody);
		refetchNotificationList.trigger();
		return response;
	}),
	deleteNotifications: newAction(async (notificationIds: string[]) => {
		const response = await notificationApi().deleteNotifications(notificationIds);
		refetchNotificationList.trigger();
		return response;
	}),
	readAllNotifications: newAction(async (options?: RawAxiosRequestConfig) => {
		const response = await notificationApi().readAllNotifications(options);
		refetchNotificationList.trigger();
		return response;
	}),
} as const;

const refetchNotificationList = debounce(() => {
	invalidate(notificationSettingsRepository.retrieveAllUserMarketNotificationsFromPool.partialQueryKey);
	invalidate(notificationSettingsRepository.retrieveAllUserPortfolioNotificationsFromPool.partialQueryKey);
}, 3000);

eventBus.on("bulk-report-download", refetchNotificationList);

eventBus.on("shared-entity", refetchNotificationList);

eventBus.on("modified-entity", refetchNotificationList);

eventBus.on("removed-entity", refetchNotificationList);

eventBus.on("deleted-entity", refetchNotificationList);

eventBus.on("shared-entities", refetchNotificationList);
